import BaseStepHandler from './BaseStepHandler';

/**
 * Handler for toggle step type
 */
export default class ToggleStepHandler extends BaseStepHandler {
    /**
     * Initialize toggle elements
     */
    initialize() {
        super.initialize();
        return this;
    }
    
    /**
     * Process template when no data exists
     */
    processTemplate() {
        // For toggle steps, we need to check if there's data first
        const stepData = this.getStepData();
        
        // If data exists and enabled is true, show the toggle
        if (stepData && stepData.enabled === true) {
            this.show();
        } else {
            // Otherwise hide the toggle
            this.hide();
        }
        
        return this;
    }
    
    /**
     * Update toggle state with step data
     * 
     * @param {object} stepData - Step data
     */
    update(stepData) {
        // Check if the toggle is enabled
        if (stepData && stepData.enabled === true) {
            this.show();
        } else {
            this.hide();
        }
        
        return this;
    }
    
    /**
     * Render panel content
     */
    renderPanelContent() {
        const stepData = this.getStepData();
        const price = this.definition.price || 0;
        
        return `
            <div class="stc-toggle-field">
                <label class="stc-switch">
                    <input type="checkbox" 
                            class="stc-toggle-switch"
                            ${stepData?.enabled ? 'checked' : ''}
                            data-price="${price}">
                    <span class="stc-slider"></span>
                </label>
                <span class="stc-toggle-label">
                    Enable ${this.definition.title}
                    ${price ? `<span class="stc-price">(+$${price})</span>` : ''}
                </span>
            </div>
        `;
    }
    
    /**
     * Bind panel events
     */
    bindPanelEvents() {
        if (!this.panelElement) return;
        
        const toggleSwitch = this.panelElement.querySelector('.stc-toggle-switch');
        const clearButton = this.panelElement.querySelector('.stc-clear-step');

        if (toggleSwitch) {
            this.addEventListener(toggleSwitch, 'change', () => {
                const stepData = this.getStepData() || {};
                stepData.enabled = toggleSwitch.checked;
                this.setStepData(stepData);
                
                // Enable/disable clear button
                if (clearButton) {
                    clearButton.disabled = !stepData.enabled;
                }
            });
        }
        
        if (clearButton) {
            this.addEventListener(clearButton, 'click', () => {
                this.clear();
            });
        }
    }

    /**
     * Get export data for toggle step
     * 
     * @returns {object} Export data
     */
    getStepExportData() {
        // Get base export data
        const exportData = super.getStepExportData();
        const stepData = this.getStepData();
        
        // Toggle steps are simpler - just track whether they're enabled
        exportData.toggleState = {
            enabled: stepData?.enabled === true,
            affectsPrice: !!this.definition.price,
            affectsProcessing: !!this.definition.affects,
            processingOptions: this.definition.affects ? {
                target: this.definition.affects.target || null,
                effect: this.definition.affects.effect || null,
                parameters: this.definition.affects.parameters || {}
            } : null
        };
        
        return exportData;
    }
    
    /**
     * Step-specific reset logic
     */
    onReset() {
        // For toggle steps, resetting just means disabling
        // The visibility will be updated in resetToDefault via the stepManager.clearStep
    }
}